import * as React from 'react';
import { Link } from 'office-ui-fabric-react';

const FeaturesSettingsTooltip = () => <div>
    Define which PPM Express features and modules should be enabled in your tenant.<br />
    Please refer to the <Link href="https://help.ppm.express/89495-ppm-express-settings/522610#section-0" target="_blank">article</Link> for more details.
</div>

export default FeaturesSettingsTooltip;
